import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  getUkSaEstimate,
  getUkTaxBoxes,
  getMtdStatus,
  getCt600,
  getUkDeadlines,
  getUkFilingDrafts,
  markUkDraftFiled,
  getCisSubcontractors,
} from '../api/ukTax';

export function useUkSaEstimate(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'sa-estimate', orgId],
    queryFn: () => getUkSaEstimate(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

export function useUkTaxBoxes(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'boxes', orgId],
    queryFn: () => getUkTaxBoxes(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

export function useMtdStatus(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'mtd-status', orgId],
    queryFn: () => getMtdStatus(orgId),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCt600(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'ct600', orgId],
    queryFn: () => getCt600(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

export function useUkDeadlines(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'deadlines', orgId],
    queryFn: () => getUkDeadlines(orgId),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUkFilingDrafts(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'filing-drafts', orgId],
    queryFn: () => getUkFilingDrafts(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

export function useMarkUkFiled(orgId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: { draftId: string; filedVia: 'qbo' | 'xero' | 'manual'; filedDate?: string }) =>
      markUkDraftFiled(orgId, args.draftId, { filedVia: args.filedVia, filedDate: args.filedDate }),
    onSuccess: () => {
      toast.success('Filing marked as filed');
      void queryClient.invalidateQueries({ queryKey: ['admin', 'taxes', 'filing-drafts', orgId] });
    },
    onError: (err: Error) => {
      toast.error(`Failed to mark filing: ${err.message}`);
    },
  });
}

export function useAdminCisSubcontractors(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'taxes', 'cis', orgId],
    queryFn: () => getCisSubcontractors(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

